import React from 'react';

import {TFIAccount} from 'notebook/tfi/TFIConstants';
import TFIUtil from 'notebook/tfi/TFIUtil';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import * as nyc from 'ui-library/NYC';

import TFIAccountItem from './TFIAccountItem';

interface TFIAccountListProps {
  accounts?: Array<TFIAccount> | null;
}

export default function TFIAccountList(props: TFIAccountListProps): JSX.Element {
  return (
    <nyc.Row fluid={true} className="u-position-relative test">
      {(() => {
        if (!props.accounts) {
          return (
            <div className="u-absolute-scroll-container">
              <CenteredHorizontalThrobber />
            </div>
          );
        } else if (props.accounts.length === 0) {
          return (
            <div className="sidepanel-fadedMessage">Add {TFIUtil.getAllowedAccountsString()} accounts.</div>
          );
        }
        return (
          <nyc.Col sm={6} className="u-absolute-scroll-container">
            {props.accounts.map((account) => (
              <TFIAccountItem key={account.id} account={account} isChild={false} />
            ))}
          </nyc.Col>
        );
      })()}
    </nyc.Row>
  );
}
